import Vue from 'vue'
import VueRouter from 'vue-router'
// import home from '../views/home.vue'
import index from '../views/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: index,
    meta: {title: '个人信息收集清单'}
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/about.vue'),
    meta: {title: ''}
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('../views/detail.vue'),
    meta: {title: '信息内容'}
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return {x: 0, y: 0}
  },
  routes
})

//修改title
router.afterEach((to, from) => {
  let title = to.meta.title;
  if (!!title) {
    document.title = title;
  }
})


export default router
